{
  "modal": {
    "buttonLabel": "Kōwhiria he wā hou",
    "text": "Kua oti kē taua wā te rahui e tētahi atu.",
    "title": "Kua tōmuri kē!"
  },
  "nextLabel": "$t(common:next): <b>Rahui i te wā whakaritenga</b>",
  "nextWeek": "Ā tērā wiki",
  "noTimeText": "Kāore he wā e wātea ana mō te rā i tīpakohia.",
  "prevWeek": "Wiki kua pahure",
  "title": "Kōwhiria tō wā whakaritenga"
}
